// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-7c983819]{fill:#f6caae}.cls-2[data-v-7c983819]{fill:#f5d3bd}.cls-3[data-v-7c983819]{fill:#eab599}.cls-4[data-v-7c983819]{fill:var(--v-primary-base)}", ""]);
// Exports
module.exports = exports;
